var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.state.error)?_c('account-create',{attrs:{"segment":_vm.segment,"storePath":_vm.accountCreateStorePath}}):_c('div',[_vm._v("\n        "+_vm._s(_vm.state.error)+"\n    ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }